var _module = require('../components/module.js');

/*
charLimit
Limits the text to the desired limit
*/
_module.filter('charLimit', function charLimitFunc() {
    return function addCommas(str, charLimit) {
        if(str.length <= charLimit) {
            return str;
        }

        var value = str.substring(0, charLimit);

        if(str.charAt(charLimit).match(/[0-9a-zA-Z]/)) {
            var substr = str.substring(charLimit);
            value += substr.substring(0, substr.search(/[^0-9a-zA-Z]/));
        }

        value  += ' ...';

        return value;
    };
});
